import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

class QuantityCell extends Component{
  constructor(props){
    super(props);
    this.state = {
      row:null
    }
  }

  componentDidMount(){
    let tmp_row = this.props.row;
    tmp_row.quantity = 1;
    this.setState({
      row:tmp_row
    })
  }

  handleInputChange = (e) => {
    let updated_service = Object.assign({}, this.state.row);
    updated_service[e.target.name] = e.target.value;
    this.setState({row:updated_service});
  }

  render(){
    if (!this.state.row) return 'Loading';
    return (
      <div className="input-group">
        <input type="text" className="form-control" name="price" type="number" step=".1" value={this.state.row.price} onChange={this.handleInputChange}/>
        <span className="input-group-append">
          <button className="btn btn-success" type="button" onClick={()=>this.props.addService(this.state.row)}>Add</button>
        </span>
      </div>
    );
  }
}

class ModalBookingServices2 extends Component {

  addService = (service) => {
    this.props.addServiceHandler(service);
  }

  render() {
    const { SearchBar } = Search;
    const columns = [{
      dataField: 'id',
      text: 'ID',
      hidden:true
    }, {
      dataField: 'name',
      text: 'Service',
      sort: true,
      headerStyle: (column, colIndex) => {
        return { width: '50%' };
      },
      formatter: (cellContent, row) => {
        return (
          <span>{row.name}</span>
        );
      }
    },{
      dataField:'orig_price',
      text: 'Price',
      headerStyle: (column, colIndex) => {
        return { width: '10%' };
      },
      formatter: (cellContent, row) => {
        let orig_price = row.price;
        return (
          <span>${orig_price}</span>
        );
      }
    },{
      dataField:'price_override',
      isDummyField:true,
      text: 'Add Service',
      headerStyle: (column, colIndex) => {
        return { width: '40%' };
      },
      formatter: (cellContent, row) => {
        return (
          <QuantityCell row={row} addService={this.addService}/>
        )
      }
    }];

    if (!this.props.booking || !this.props.service_list) return <div className="alert alert-danger">No Booking Loaded</div>;
    return (
    	<React.Fragment>
        <ToolkitProvider
          bootstrap4
          keyField="id"
          data={this.props.service_list}
          columns={columns}
          search={{searchFormatted:true}}
          srText="Search"
        >
          {
            props => (
              <div className="mt-20">
                <form role="form" id="accounts-form" className="form-type-combine">
                  <div className="form-groups-attached">
                    <div className="row">
                      <div className="form-group col-lg-3 col-md-4 col-sm-12">
                        <label>Search anything</label>
                        <SearchBar { ...props.searchProps } />
                      </div>
                    </div>
                  </div>
                </form>
                <BootstrapTable classes="table table-condensed table-striped m-b-20" {...props.baseProps} headerClasses="thead-light"/>
              </div>
            )
          }
        </ToolkitProvider>
      </React.Fragment>
    );
  }
}

export default ModalBookingServices2;



// WEBPACK FOOTER //
// ./src/components/business/ModalBookingServices2.js